export default __webpack_public_path__ + "static/media/closed_arrow.a6246610.svg";